import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';

class ProgressGraph extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }

    render() {
        const { value, response, color } = this.props;
        return (
            <div className="card-progress card-top">
                <ProgressBar now={parseInt(value)} variant={`${color == '' ? 'primary' : color}`} />
                <div className="progress-content card-top">
                    <h3>{response}</h3>
                    <h3>{value}%</h3>
                </div>
            </div>
        );
    }

}

export default ProgressGraph;
